import React, { useState } from "react"

import { Grid } from "@material-ui/core"

import {
	Text
} from "letalkui"

import { Loading, Breadcrumb } from "@/components"

import BoardItem from "@/pages/Admin/Boards/BoardList/BoardItem"

import BoardListSkeleton from "@/skeletons/Admin/BoardListSkeleton"

import BoardService, { BoardFormattedForList } from "@/services/BoardService"
import ErrorHandlerService from "@/services/ErrorHandler"

import { ErrorType } from "@/hooks/useValidation"
import useDidMount from "@/hooks/useDidMount"
import { colors } from "@/styles/colors"

const BoardList = () => {
	const [loading, setLoading] = useState<boolean>(false)
	const [boards, setBoards] = useState<Array<BoardFormattedForList>>([])

	const handleGetBoards = async () => {
		setLoading(true)

		try {
			const formattedBoards = await BoardService.getOrCreateBoard()

			setBoards(formattedBoards)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
		}

		setLoading(false)
	}

	useDidMount(() => {
		handleGetBoards()
	})

	return (
		<Grid
			container
			spacing={3}
		>
			<Grid
				item
				xs={12}
			>
				<Breadcrumb
					data={[
						{ name: "Funil de Vendas", pathname: "/admin/funnel" }
					]}
				/>
			</Grid>
			<Grid
				item
				xs={12}
			>
				<Grid
					container
					justifyContent="space-between"
					alignItems="center"
				>
					<Grid item>
						<Grid
							container
							alignItems="center"
							spacing={2}
						>
							<Grid item>
								<Grid container spacing={2}>
									<Grid item>
										<Text.Title
											type="h1"
											fontWeight="bold"
											color={colors.gray[900]}
										>
											Lista de Funis de Vendas
										</Text.Title>
									</Grid>
								</Grid>
							</Grid>
							{/* <Grid item>
								<Chip
									className={classes.statusChip}
									label={(
										<Text.Body
											type="small2"
											fontWeight="semibold"
										>
											{`${boards.length} boards`}
										</Text.Body>
									)}
								/>
							</Grid> */}
						</Grid>
					</Grid>
					{/* <Grid item>
						<CreateBoardDialog>
							<Button.Primary
								size="small"
								startIcon={<AddIcon />}
							>
								Adicionar board
							</Button.Primary>
						</CreateBoardDialog>
					</Grid> */}
				</Grid>
			</Grid>
			<Grid
				item
				xs={12}
			>
				<Loading
					loading={loading}
					customLoadingElement={<BoardListSkeleton />}
				>
					<Grid
						container
						spacing={2}
					>
						{boards?.map(board => (
							<Grid
								item
								xs={12}
								key={board.id}
							>
								<BoardItem
									board={{
										id: board.id,
										name: board.name
									}}
								/>
							</Grid>
						))}
					</Grid>
				</Loading>
			</Grid>
		</Grid>
	)
}

export default BoardList
